import { render, staticRenderFns } from "./BarangDariPusatKp.vue?vue&type=template&id=4e6c0c16&"
import script from "./BarangDariPusatKp.vue?vue&type=script&lang=js&"
export * from "./BarangDariPusatKp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports